import PrimaryFooter from './PrimaryFooter';

export default PrimaryFooter;
